import { createSelector } from 'reselect';

export const thankYouPageSelector = state => state.thankYouPage;

export const thankYouPageApiDataSelector = createSelector(thankYouPageSelector, thankYouPage => {
  return thankYouPage.data;
});

export const isLoadingSelector = createSelector(thankYouPageSelector, thankYouPage => {
  return thankYouPage.isLoading;
});

export const paymentIdSelector = createSelector(thankYouPageSelector, thankYouPage => {
  return thankYouPage.payment_id;
});

export const paymentSessionIdSelector = createSelector(thankYouPageSelector, thankYouPage => {
  return thankYouPage.pay_session_id;
});

export const apiHitCountSelector = createSelector(thankYouPageSelector, thankYouPage => {
  return thankYouPage.apiHitCount;
});

export const hitApiSelector = createSelector(thankYouPageSelector, thankYouPage => {
  return thankYouPage.hitApi;
});

export const thankYouPageInfoSelector = createSelector(
  thankYouPageApiDataSelector,
  thankYouPageApiData => {
    return thankYouPageApiData?.pageInfo || null;
  }
);

export const thankYouPageAnalyticsInfoSelector = createSelector(
  thankYouPageApiDataSelector,
  thankYouPageApiData => {
    return thankYouPageApiData?.analytics || null;
  }
);

export const thankYouTokenSelector = createSelector(thankYouPageSelector, thankYouPage => {
  return thankYouPage?.token || null;
});

export const tqOmnitureInfoSelector = createSelector(thankYouPageSelector, thankyouPage => {
  return thankyouPage?.tqOmnitureInfo;
});

export const tqMissedOmnitureEventsSelector = createSelector(thankYouPageSelector, thankyouPage => {
  return thankyouPage?.tqMissedOmnitureEvents;
});
